import { render, staticRenderFns } from "./DetailsXydai.vue?vue&type=template&id=1db7b896&scoped=true&"
import script from "./DetailsXydai.vue?vue&type=script&lang=js&"
export * from "./DetailsXydai.vue?vue&type=script&lang=js&"
import style0 from "./DetailsXydai.vue?vue&type=style&index=0&id=1db7b896&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7b896",
  null
  
)

export default component.exports